import { render, staticRenderFns } from "./TeacherValue.vue?vue&type=template&id=1997375b"
import script from "./TeacherValue.vue?vue&type=script&lang=js"
export * from "./TeacherValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports